export default __webpack_public_path__ + "static/media/logo_Hermes.a1bdc9f3.png";